import {
  Backdrop,
  CircularProgress,
  Typography,
  Box,
  BackdropProps,
} from '@mui/material';
import { neutralColors } from '../../../../theme/colors';

// ===========================================
// LoadingOverlay - Full-screen loading overlay
// ===========================================

export interface LoadingOverlayProps extends Omit<BackdropProps, 'children'> {
  message?: string;
  spinnerSize?: number;
  showSpinner?: boolean;
}

export function LoadingOverlay({
  open,
  message = 'Loading...',
  spinnerSize = 40,
  showSpinner = true,
  sx,
  ...props
}: LoadingOverlayProps) {
  return (
    <Backdrop
      sx={{
        color: neutralColors.white,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        flexDirection: 'column',
        gap: 2,
        ...sx,
      }}
      open={open}
      {...props}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        {showSpinner && (
          <CircularProgress
            color="inherit"
            size={spinnerSize}
            sx={{ color: neutralColors.white }}
          />
        )}
        {message && (
          <Typography
            variant="body1"
            color="inherit"
            sx={{
              color: neutralColors.white,
              textAlign: 'center',
              maxWidth: '300px',
            }}
          >
            {message}
          </Typography>
        )}
      </Box>
    </Backdrop>
  );
}
